import { NotificationTemplate } from "../index";

export const TINVerificationPending: NotificationTemplate<never> = {
  isPending: true,
  renderTitle: props => "Validating TIN with the IRS",
  renderBody: props => {
    return "Wingspan is waiting to hear back from the IRS on whether or not the TIN you provided is accurate — we’ll let you know when this complete!";
  }
};
